(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/utils/assets/javascripts/reduction-indices.js') >= 0) return;  svs.modules.push('/components/pool-betting/utils/assets/javascripts/reduction-indices.js');
"use strict";

const {
  ScoreReductions
} = svs.components.sport.tipsenShared.constants;
const reductionIndices = Object.values(ScoreReductions).map(reduction => reduction.index).sort((a, b) => a - b);
setGlobal('svs.components.poolBetting.utils.reductionIndices', reductionIndices);

 })(window);